import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Direction } from '../../models/direction.enum';
import { DataService } from '../../services/data.service';
import { ChangeRequestService } from '../../services/changerequest.service';
import { LineItemModel } from '../../models/lineitemmodel';
import { AuthorityPointGroup } from '../../models/authoritypointgroup';
import { AuthorityPoint } from '../../models/authoritypoint';
import { PointType } from '../../models/pointtype.enum';
import { ReportBy } from '../../models/reportby';
import { Track } from '../../models/track';
import { TrackAuthority } from '../../models/trackauthority';
import { ChangeRequest } from '../../models/changerequest';
import { User } from '@csx/security';
import { LineItem } from '../../models/lineitem';
import { UtilService } from '../../services/util.service';
import { CommentType } from '../../models/commenttype.enum';
import { Comment } from '../../models/comment';
import { ATMEventData, EventBusService, EventType } from '../../services/eventbus.service';
import { HttpResponse } from '../../models/http';
import { DataShareService } from '../../services/data-share.service';
import { IConfirmationDialogModel } from '../../models/confirmaDialogModel';
import { LineItemModify } from '../../models/lineItemmodify';
import { Modification } from '../../models/modification';
import { Subject } from '../../../../node_modules/rxjs';
import { Status } from '../../models/status.enum';
import { ChangeRequestType } from '../../models/changerequesttype.enum';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'change-request',
  templateUrl: './changerequest.component.html',
  styleUrls: ['./changerequest.component.scss']
})
export class ChangeRequestComponent implements OnChanges {
  @Output() onCloseDialog = new EventEmitter();
  @Input() display = false;
  @Input() authority: TrackAuthority;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancelShareModification = new EventEmitter();
  resetDirection: Subject<any> = new Subject();

  authorityForAffirmation: TrackAuthority = null;
  changeRequestForAffirmation: ChangeRequest;
  authorityPointGroupList: AuthorityPointGroup[];
  filteredOperatingFromList: AuthorityPointGroup[];
  trackListOperatingFrom: SelectItem[] = new Array<SelectItem>();
  directionListForModify: SelectItem[];
  Direction = Direction;
  UserClickedReportBy = false;
  line11TrainLock = false;
  timerCheck = false;

  errorMessageSelectedLocation: string = null;
  errorMessageSelectedTrackFrom: string = null;
  errorMessageInvalidTime: string = null;

  selectedTrack: AuthorityPoint;
  selectedLocation: AuthorityPointGroup;
  showDialog = false;
  lineItemsModify: Array<LineItem>;
  openConfirmation = false;

  minDate: Date = new Date();
  blockDialog = false;
  oldExpiration: Date;
  expirationHour: number;
  expirationMins: number;
  confirmationDialogData: IConfirmationDialogModel;
  showConfirmation: boolean;
  localDate: Date;
  directionCancel: Direction;
  directions: Array<Direction> = [];
  readOnlyOldExpiration: Date;
  readOnlyExpirationMins: number;
  readOnlyExpirationHour: number;
  constructor(
    private dataService: DataService,
    private changeRequestService: ChangeRequestService,
    private user: User,
    private eventBus: EventBusService,
    private dataShareService: DataShareService
  ) {
    this.showConfirmation = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.resetModify();
    this.showDialog = this.authority !== null;
    this.getAuthorityPointsForModify();
    this.getReportByLock();
    this.getDirectionLock();
    if (this.authority !== null) {
      this.localDate = UtilService.estToLocal(this.authority.expiration);
      this.lineItemsModify = this.authority.lineItems;
      this.expirationHour = this.getHours(this.localDate);
      this.expirationMins = this.getMinutes(this.localDate);
      this.oldExpiration = this.localDate;
      this.readOnlyExpirationHour = this.getHours(this.localDate);
      this.readOnlyExpirationMins = this.getMinutes(this.localDate);
      this.readOnlyOldExpiration = this.localDate;
    }
  }

  getReportByLock(): boolean {
    if (this.authority !== null) {
      for (let lineItemModel of this.authority.lineItems) {
        if (lineItemModel.cancelled === undefined) {
          this.directionCancel = lineItemModel.direction;
          break;
        }
      }
      for (let lineItemModel of this.authority.lineItems) {
        if (
          (lineItemModel.cancelled === undefined && lineItemModel.direction === Direction.Both) ||
          (lineItemModel.cancelled === undefined && lineItemModel.direction !== this.directionCancel)
        ) {
          return true;
        }
      }
    }
    return false;
  }

  getAuthorityPointsForModify(): void {
    if (this.authority !== null) {
      this.setBlock(true);
      this.dataService
        .getAuthorityPointsByPrefixMilepostRange(
          this.authority.entryLocation.prefix,
          this.authority.entryLocation.milepost,
          this.authority.entryLocation.range
        )
        .then(
          response => {
            this.setBlock(false);
            this.authorityPointGroupList = response;
          },
          error => {
            this.setBlock(false);
            this.authorityPointGroupList = [];
          }
        );
    }
  }

  search(event): void {
    const query = event.query.toLowerCase();
    let filteredList = new Array<AuthorityPointGroup>();
    if (this.authorityPointGroupList !== null) {
      for (let i = 0; i < this.authorityPointGroupList.length; i++) {
        let authorityPoint: AuthorityPointGroup = this.authorityPointGroupList[i];
        if (query === '' || authorityPoint.commonName.toLowerCase().indexOf(query) === 0) {
          filteredList.push(authorityPoint);
        }
      }
    }

    this.filteredOperatingFromList = filteredList;
  }

  operatingFromSelected() {
    this.selectedTrack = null;
    if (typeof this.selectedLocation === 'string' || this.selectedLocation instanceof String) {
      const operatingFrom = this.selectedLocation.toUpperCase();
      for (let operatingPoint of this.filteredOperatingFromList) {
        if (operatingPoint.commonName === operatingFrom) {
          this.selectedLocation = operatingPoint;
          break;
        }
      }
    }
    this.errorMessageSelectedLocation = this.handleBlur(this.selectedLocation, this.trackListOperatingFrom);
    this.trackListOperatingFrom = [...this.trackListOperatingFrom];
    if (this.errorMessageSelectedLocation !== null) {
      this.trackListOperatingFrom = [{ label: 'Select Track', value: null }];
      this.selectedTrack = null;
    }
  }

  private handleBlur(operatingLocation: AuthorityPointGroup, trackList: SelectItem[]): string {
    if (typeof operatingLocation === 'string' || operatingLocation instanceof String) {
      let operatingLocationStr: string = (operatingLocation + '').toUpperCase();
      let validationString: string = LineItemModel.validateStringAuthorityPoint(operatingLocationStr);
      if (validationString !== null) {
        return validationString;
      }
      let arr: string[] = operatingLocationStr.split(' ');
      let prefix: string = arr[0];
      let milepost: string = arr[1];

      this.dataService
        .getTracksByPrefixMilepost(prefix, milepost)
        .then(response => {
          trackList.splice(0);
          if (response !== undefined) {
            for (let item of response) {
              let authorityPoint: AuthorityPoint = {
                type: PointType.MILEPOST,
                displayName: prefix + ' ' + milepost,
                location: {
                  prefix: prefix,
                  milepost: milepost,
                  track: new Track(item)
                }
              } as AuthorityPoint;
              trackList.push({ label: authorityPoint.location.track.name, value: authorityPoint });
            }
            this.trackListOperatingFrom = [...trackList];
          }
        })
        .catch(exc => { });
    } else if (operatingLocation !== undefined && operatingLocation !== null) {
      this.populateTrackListFromAuthorityPointList(operatingLocation.points, trackList);
    }
    return null;
  }

  private populateTrackListFromAuthorityPointList(authorityPointList: AuthorityPoint[], trackList: SelectItem[]) {
    trackList.splice(0);
    if (authorityPointList === undefined || authorityPointList === null) {
      return;
    }

    let trackCountMap: Map<string, number> = new Map<string, number>();

    authorityPointList.forEach((authorityPoint: AuthorityPoint) => {
      let track: string = authorityPoint.location.track.name;
      if (trackCountMap.get(track) === undefined) {
        trackCountMap.set(track, 0);
      }
      trackCountMap.set(track, trackCountMap.get(track) + 1);
    });

    authorityPointList.forEach((authorityPoint: AuthorityPoint) => {
      let label: string = authorityPoint.location.track.name;
      if (trackCountMap.get(label) > 1) {
        label =
          label + '(' + authorityPoint.location.prefix + ' ' + Math.round(parseFloat(authorityPoint.location.milepost) * 100) / 100 + ')';
      }
      trackList.push({ label: label, value: authorityPoint });
    });
  }

  openChangeRequestPopup(): void {
    this.showDialog = true;
  }

  setBlock(visible: boolean): void {
    this.blockDialog = visible;
  }

  close(): void {
    this.onClose.emit();
  }

  closeModify(): void {
    this.showDialog = false;
    this.onClose.emit();
    this.line11TrainLock = false;
    this.resetModify();
  }
  resetModify(): void {
    this.selectedLocation = undefined;
    this.errorMessageSelectedLocation = null;
    this.errorMessageSelectedTrackFrom = null;
    this.errorMessageInvalidTime = null;
    this.trackListOperatingFrom = [{ label: 'Select Track', value: null }];
    this.selectedTrack = null;
    this.filteredOperatingFromList = [];
    this.resetCancelledItems();
    if (this.authority !== null) {
      this.expirationHour = this.getHours(this.localDate);
      this.expirationMins = this.getMinutes(this.localDate);
      this.oldExpiration = this.localDate;
    }
    this.resetDirections();
  }

  resetDirections() {
    this.resetDirection.next('Reset Direction');
  }

  transformData(): ChangeRequest {
    let reportBy: ReportBy = null;
    if (typeof this.selectedLocation === 'string' || this.selectedLocation instanceof String) {
      reportBy = {
        type: PointType.MILEPOST,
        displayName: this.selectedTrack.displayName,
        dispatchPoint: this.selectedTrack.dispatchPoint,
        dispatchablePoint: this.selectedTrack.dispatchablePoint,
        location: this.selectedTrack.location,
        direction: this.directionCancel
      } as ReportBy;
    } else {
      for (let authorityPoints of this.selectedLocation.points) {
        if (
          authorityPoints.location.track.code === this.selectedTrack.location.track.code &&
          authorityPoints.location.track.name === this.selectedTrack.location.track.name
        ) {
          reportBy = {
            type: this.selectedLocation.type,
            displayName: authorityPoints.displayName,
            dispatchPoint: this.selectedTrack.dispatchPoint,
            dispatchablePoint: authorityPoints.dispatchablePoint,
            location: this.selectedTrack.location,
            direction: this.directionCancel
          } as ReportBy;
        }
      }
    }

    let changeRequest: ChangeRequest = {
      trackAuthorityId: this.authority.id,
      confirmationAction: Status.CHANGE_REQUEST.toString(),
      type: ChangeRequestType.REPORTBY.toString(),
      reportBy: reportBy
    } as ChangeRequest;

    return changeRequest;
  }

  getLineNumberIdentifier(charCode: number): string {
    return String.fromCharCode(charCode);
  }

  getHours(expiration: Date) {
    return expiration ? expiration.getHours() : null;
  }

  getMinutes(expiration: Date) {
    return expiration ? expiration.getMinutes() : null;
  }

  getCommentType(comments: Array<any>, ptype: string) {
    let result = [];
    if (comments && comments.length > 0) {
      result = comments.filter(item => item.type === ptype);
    }
    return result;
  }

  isCommentsHaving(comments: Array<any>, ptype: string): boolean {
    for (let comment of comments) {
      if (comment.type === ptype) {
        return true;
      }
    }
    return false;
  }

  getCommentList(): Array<Comment> {
    return UtilService.getFirstCommentOfTypes(this.authority.comments, [CommentType.PRIVATE]);
  }
  onSubmitOpenConfirmations() {
    let changeRequest: ChangeRequest;
    if (this.UserClickedReportBy === true) {
      let isValid = true;
      if (this.selectedLocation === undefined || this.selectedLocation === null) {
        this.errorMessageSelectedLocation = 'Required';
        isValid = false;
      }
      if (this.selectedTrack === undefined || this.selectedTrack === null) {
        this.errorMessageSelectedTrackFrom = 'Required';
        isValid = false;
      }
      if (!isValid) {
        return;
      } else {
        this.errorMessageSelectedTrackFrom = null;
      }
      changeRequest = this.transformData();
    } else if (this.isLineItemModified() || this.isUntilTimeChanged()) {
      let extendedTime: Date;
      if (this.isUntilTimeChanged() && this.errorMessageInvalidTime === null) {
        let validDateTime: Date = this.setInputDate();
        extendedTime = UtilService.localToEST(validDateTime);
      }

      let lineItemModifyList: LineItemModify[];
      if (this.isLineItemModified()) {
        lineItemModifyList = [];
        this.lineItemsModify.forEach(item => {
          if (item.isUserCancelled) {
            let lineItemModify = new LineItemModify({
              lineNumber: item.id,
              isCancelled: item.isUserCancelled
            });
            lineItemModifyList.push(lineItemModify);
          }
          if (item.newDirection !== item.direction) {
            let lineItemModify = new LineItemModify({
              lineNumber: item.id,
              direction: item.newDirection
            });
            lineItemModifyList.push(lineItemModify);
          }
        });
      }
      let modification: Modification = null;
      modification = {
        untilTime: extendedTime,
        lineItems: lineItemModifyList
      } as Modification;
      changeRequest = {
        eic: { racf: this.user.racf, employeeId: '', name: this.user.displayName },
        trackAuthorityId: this.authority.id,
        confirmationAction: Status.CHANGE_REQUEST.toString(),
        type: ChangeRequestType.MODIFY.toString(),
        modification: modification
      } as ChangeRequest;
    }
    if (this.authority.isAuthorityShared) {
      this.setBlock(true);
      this.changeRequestService
        .postChangeRequest(changeRequest, this.authority)
        .then(
          success => {
            this.dataShareService.setModifyOrReportByChangeRequestStatus(this.authority, 'CR');
            this.eventBus.fireEvent(EventType.AUTHORITY_UPDATED_EVENT, new ATMEventData(this.authority, () => { }));
            this.setBlock(false);
            this.onClose.emit();
          },
          (error: HttpResponse) => {
            this.setBlock(false);
            this.onClose.emit();
          }
        )
        .catch(response => {
          this.setBlock(false);
          this.onClose.emit();
        });
    } else {
      this.changeRequestForAffirmation = changeRequest;
      this.authorityForAffirmation = this.authority;
      this.openConfirmation = true;
    }
  }

  closeDialog(event: any): void {
    this.openConfirmation = false;
    this.authorityForAffirmation = null;
  }
  submitFromAffirmation() {
    this.onCloseDialog.emit({ value: 'false' });
    this.resetModify();
  }

  isLineItemModified(): boolean {
    let x: boolean;
    this.lineItemsModify.forEach(item => {
      if (item.isUserCancelled || item.newDirection !== item.direction) {
        x = true;
      }
    });
    if (x === true) {
      return true;
    } else {
      return false;
    }
  }

  isReportByTouched() {
    if (this.selectedLocation !== undefined) {
      this.UserClickedReportBy = true;
    } else {
      this.UserClickedReportBy = false;
    }
    return this.selectedLocation !== undefined;
  }

  undoAction(item: LineItem): void {
    item.isUserCancelled = false;
  }

  clickCancel(item: LineItem): void {
    item.isUserCancelled = true;
    item.newDirection = item.direction;
  }

  getActiveCount(): number {
    let count = 0;
    this.lineItemsModify.forEach(item => {
      if (!item.isUserCancelled && item.cancelled === undefined) {
        count++;
      }
    });
    return count;
  }
  resetCancelledItems(): void {
    if (this.lineItemsModify !== null && this.lineItemsModify !== undefined) {
      this.lineItemsModify.forEach(item => {
        if (item.isUserCancelled) {
          item.isUserCancelled = false;
        }
      });
    }
  }

  isUntilTimeChanged(): boolean {
    const originLocalDate = UtilService.estToLocal(this.authority.expiration);
    return (
      originLocalDate.getHours() !== this.expirationHour ||
      originLocalDate.getMinutes() !== this.expirationMins ||
      originLocalDate.getDate() !== this.oldExpiration.getDate() ||
      originLocalDate.getMonth() !== this.oldExpiration.getMonth() ||
      originLocalDate.getFullYear() !== this.oldExpiration.getFullYear()
    );
  }

  invalidUntilTime(): boolean {
    if (
      this.expirationHour === null ||
      this.expirationMins === null ||
      this.expirationHour < 0 ||
      this.expirationHour > 23 ||
      this.expirationMins < 0 ||
      this.expirationMins > 59
    ) {
      this.errorMessageInvalidTime = 'Invalid Until Date & Time';
      this.timerCheck = true;
      return true;
    }
    let currentDate = new Date();
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);
    let inputDateTime: Date = this.setInputDate();
    let existingExpiration: Date = this.existingExpirationDate();
    if (inputDateTime.valueOf() <= currentDate.valueOf() || inputDateTime.valueOf() < existingExpiration.valueOf()) {
      this.errorMessageInvalidTime = 'Invalid Until Date & Time';
      this.timerCheck = true;
      return true;
    } else {
      this.errorMessageInvalidTime = null;
      return false;
    }
  }

  setInputDate(): Date {
    let genericDate: Date = new Date();
    genericDate.setDate(this.oldExpiration.getDate());
    genericDate.setMonth(this.oldExpiration.getMonth());
    genericDate.setFullYear(this.oldExpiration.getFullYear());
    genericDate.setHours(this.expirationHour);
    genericDate.setMinutes(this.expirationMins);
    genericDate.setSeconds(0);
    genericDate.setMilliseconds(0);
    return genericDate;
  }

  existingExpirationDate(): Date {
    let genericDate: Date = new Date();
    genericDate.setDate(this.readOnlyOldExpiration.getDate());
    genericDate.setMonth(this.readOnlyOldExpiration.getMonth());
    genericDate.setFullYear(this.readOnlyOldExpiration.getFullYear());
    genericDate.setHours(this.readOnlyExpirationHour);
    genericDate.setMinutes(this.readOnlyExpirationMins);
    genericDate.setSeconds(0);
    genericDate.setMilliseconds(0);
    return genericDate;
  }

  getDirectionLock() {
    if (this.authority !== null) {
      let line11Comments: Comment[];
      line11Comments = this.getLine11Items();
      for (let comment of line11Comments) {
        if (comment.text.toUpperCase().match(/\bTRAIN\b/) || comment.text.toUpperCase().match(/\bTRAINS\b/)) {
          this.line11TrainLock = true;
          return true;
        }
      }
    }
  }

  getLine11Items(): Array<Comment> {
    return this.authority.comments.filter(comment => UtilService.isCommentOfType(comment, [CommentType.LINE11]));
  }
  showCloseModal() {
    this.onCancelShareModification.emit({ ec1Number: this.authority.ec1Number });
  }

  confirmationAccepted(event: any): void {
    this.showConfirmation = false;
  }
  confirmationCancelled(event: any): void {
    this.showConfirmation = false;
  }
}
